// Kept dependency-free in its own module so callers (e.g. the duty version
// pane's plain sections) can import it statically without pulling the heavy
// @git-diff-view chunk that DiffViewer.tsx lazy-loads.

// Any non-string value is shown as pretty JSON; null/undefined as empty file.
export function toText(value: unknown): string {
  if (value === null || value === undefined) return ''
  if (typeof value === 'string') return value
  try {
    return JSON.stringify(value, null, 2)
  } catch {
    return String(value) // circular refs etc. — never throw during render
  }
}
